import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import ProjectDetail from './pages/ProjectDetail';
import Contact from './pages/Contact';
import Projets from './pages/Projets';
import Agence from './pages/Agence';
import Carrieres from './pages/Carrieres';
import Actualites from './pages/Actualites';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/admin/ProtectedRoute';
import AdminLogin from './pages/admin/Login';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/Dashboard';
import AdminProjectsList from './pages/admin/ProjectsList';
import AdminProjectForm from './pages/admin/ProjectForm';
import AdminNewsList from './pages/admin/NewsList';
import AdminPhilosophyForm from './pages/admin/PhilosophyForm';

// Browser-language detection on first visit at root "/"
const RootRedirect = () => {
  let preferred = 'fr';
  try {
    const stored = localStorage.getItem('smarch_lang');
    if (stored === 'fr' || stored === 'en') preferred = stored;
    else if (typeof navigator !== 'undefined' && navigator.language && navigator.language.toLowerCase().startsWith('en')) {
      preferred = 'en';
    }
  } catch { /* ignore */ }
  return <Navigate to={`/${preferred}`} replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Root → preferred language */}
            <Route path="/" element={<RootRedirect />} />

            {/* French public routes */}
            <Route path="/fr" element={<Home />} />
            <Route path="/fr/projets" element={<Projets />} />
            <Route path="/fr/projets/:slug" element={<ProjectDetail />} />
            <Route path="/fr/agence" element={<Agence />} />
            <Route path="/fr/carrieres" element={<Carrieres />} />
            <Route path="/fr/actualites" element={<Actualites />} />
            <Route path="/fr/contact" element={<Contact />} />

            {/* English public routes */}
            <Route path="/en" element={<Home />} />
            <Route path="/en/projects" element={<Projets />} />
            <Route path="/en/projects/:slug" element={<ProjectDetail />} />
            <Route path="/en/agency" element={<Agence />} />
            <Route path="/en/careers" element={<Carrieres />} />
            <Route path="/en/news" element={<Actualites />} />
            <Route path="/en/contact" element={<Contact />} />

            {/* Legacy redirects (preserve old URLs / external links) */}
            <Route path="/projets" element={<Navigate to="/fr/projets" replace />} />
            <Route path="/projet/:slug" element={<LegacyProjectRedirect />} />
            <Route path="/agence" element={<Navigate to="/fr/agence" replace />} />
            <Route path="/carrieres" element={<Navigate to="/fr/carrieres" replace />} />
            <Route path="/actualites" element={<Navigate to="/fr/actualites" replace />} />
            <Route path="/contact" element={<Navigate to="/fr/contact" replace />} />

            {/* Admin (untranslated) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="projects" element={<AdminProjectsList />} />
              <Route path="projects/new" element={<AdminProjectForm />} />
              <Route path="projects/:slug" element={<AdminProjectForm />} />
              <Route path="news" element={<AdminNewsList />} />
              <Route path="philosophy" element={<AdminPhilosophyForm />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

// Tiny helper component to preserve old "/projet/:slug" links
function LegacyProjectRedirect() {
  const slug = window.location.pathname.split('/').pop();
  return <Navigate to={`/fr/projets/${slug}`} replace />;
}

export default App;
